import { compose, withPropsOnChange } from "recompose"

import { getPlannedMts } from "../../api/entities/plannedMts"
import withApiTransport from "../../api/apiTransport"

const enhance = compose(
  withPropsOnChange([`sapIssueId`], ({ sapIssueId }) => ({
    load: getPlannedMts,
    propName: `plannedMts`,
    payload: sapIssueId,
  })),
  withApiTransport,
)

export default enhance
